module.exports = __webpack_public_path__ + "img/screen-agrupador-02.3d4a5f45.png";